import React from "react";
import PropTypes from "prop-types";
import {t} from "i18next";
import {CardListItem} from "components/Card";
import ExternalRouteButton from "components/ExternalRouteButton";
import {EntityTitle} from "../Components/EntityTitle";

const IndicatorsListItem = ({
  tooltip,
  count,
  showEventsCount = true,
  showLinks = false,
  minimal,
  entity,
  ...otherProps
}) => {
  const {value, title, source, source_uri} = entity;

  return (
    <CardListItem
      title={
        <EntityTitle
          title={
            showLinks && source_uri ? (
              <ExternalRouteButton
                text={value || title}
                href={source_uri}
                data-testid={`indicator-item-${value || title}`}
              />
            ) : (
              value || title
            )
          }
          {...{
            tooltip,
            minimal
          }}
        />
      }
      subtitle={source}
      rightSide={
        showEventsCount ? t("overview.cards.eventCount", {count}) : null
      }
      minimal={minimal}
      entity={entity}
      {...otherProps}
    />
  );
};

IndicatorsListItem.propTypes = {
  /**
   * Data object for entity
   */
  entity: PropTypes.object,
  /**
   * Object with `title` and `subtitle` keys to show as tooltip.
   */
  tooltip: PropTypes.object,
  /**
   * If provided, an event count will be shown in the `rightSide` section.
   * This has no effect for if `minimal={true}`.
   */
  count: PropTypes.number,
  /**
   * Default: true.
   *
   * by default a `<PlusMoreTag/>` will be shown below the list if:
   * - `limit` props is defined.
   * - data.length > limit
   *
   * To disable this behavior set showEventsCount={false}
   */
  showEventsCount: PropTypes.bool,
  /**
   * Default Value: false - Render normal view (Cards, Drawers, etc.)
   * true - Renders a more compact view used by Tables. note that some sections
   * like 'subtitle' and 'rightSide' event counts are never show in this mode.
   */
  minimal: PropTypes.bool,
  /**
   * Remaining Entity properties passed through to CardListItem
   */
  otherProps: PropTypes.object
};

export default React.memo(IndicatorsListItem);
